import { Dialog as PrimeDialog } from "primereact/dialog";

import type { DialogViewProps } from "./types-dialog";

export function DialogView({ dialogRef, dialogProps }: DialogViewProps) {
  return <PrimeDialog ref={dialogRef} {...dialogProps} />;
}
